export const ReactQuerySettings = {
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  retry: 5,
  retryDelay: (attempt: number) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
};
